import { createMuiTheme, Grid, responsiveFontSizes, Theme, ThemeOptions, ThemeProvider } from '@material-ui/core';
import { useEffect, useMemo, useState } from 'react';
import { BrowserRouter,  Redirect,  Route, Switch } from 'react-router-dom';
import { AppContext } from '../../context/context';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Home from '../Home/Home';
import List from '../List/List';
import Mission from '../Mission/Mission';
import Campaign from '../Campaign/Campaign';
import CampaignModal from '../CampaignModal/CampaignModal';
import { isNull } from 'util';
import { GridColumns } from '@material-ui/data-grid';
import { SharedData } from '../../Interfaces/Interfaces';


const currentTheme:ThemeOptions = {
    palette: {
        primary: {
            main: '#0A2E48'
        },
        secondary: {
            main: '#FFBE04'
        },
    },
}

const rawTheme = createMuiTheme(currentTheme);
const theme = responsiveFontSizes(rawTheme)


function Layout() {

    const [sharedData, setSharedData] = useState<SharedData>({
        isModalActive: false,
        modalTarget: "",
        modalPayload: [],
        isLogged: false,
        username: ""
    });

    const localData = useMemo(() => JSON.parse(localStorage.getItem("user") as any),[]);

    useEffect(() => {
        if (!isNull(localData)) {
            setSharedData((prevState) => ({ ...prevState,isLogged:true,username:localData.username}))
        } 
    }, [localData, setSharedData])

    const missionsListColumns: GridColumns = [
        { field: 'name', headerName: 'Mission Name' , flex: 1, width: 250, headerAlign: 'left', align: 'left' },
        { field: 'hash', headerName: 'Instance', flex: .5, width: 130, headerAlign: 'center', align: 'center' },
        { field: 'createdDate', headerName: 'Date', /*type: 'date',*/ flex: .75, width: 130, headerAlign: 'center', align: 'center' }
    ];


    const CampaignsListColumns: GridColumns = [  
        { field: 'name', headerName: 'Campaign Name' /*, flex: 1*/, width: 250, headerAlign: 'left', align: 'left' },
        { field: 'description', headerName: 'Description', flex: 1, width: 100, headerAlign: 'center', align: 'center' },
        { field: 'createdDate', headerName: 'Date', /*type: 'date',*/ flex: 1, width: 150, headerAlign: 'center', align: 'center' },
    ];
    
    return (
        <BrowserRouter>
            <ThemeProvider<Theme> theme={theme}>
                <AppContext.Provider value={{ sharedData, setSharedData}} >
                    <Grid
                        container
                        justify="center"
                        alignItems="center"
                        direction="column"
                    >
                        <Grid item xs={12}>
                            <Header />
                        </Grid>
                        <Grid item xs={12} style={{ marginBottom: 50 }}>
                            <CampaignModal headers={missionsListColumns} />
                            <Switch>                                     
                                <Route exact path="/">
                                    <Home />
                                </Route>
                                <Route path="/missions">
                                    <List target="missions" headers={missionsListColumns} deletableContent />  
                                </Route>
						        <Redirect exact from="/mission/:id" to="/Mission/:id/Summary" />
                                <Route path="/mission/:id">
                                     <Mission />
                                </Route>
                                <Route path="/campaigns">
                                    <List target="campaigns" headers={CampaignsListColumns} createContent deletableContent />  
                                </Route>
                                <Route path="/campaign/:id">
                                    <Campaign headers={missionsListColumns} />
                                </Route>
                            </Switch>
                        </Grid>
                        <Grid item xs={12}>
                            <Footer />
                        </Grid>
                    </Grid>
                </AppContext.Provider>
            </ThemeProvider>
        </BrowserRouter>
  );
}

export default Layout;
